import { CSSProperties, ReactElement, useState } from 'react';

import { Theme, SxProps, Box, Typography } from '@mui/material';

type NuggetInstitutionProps = Readonly<{
  variant:
    | {
        type: 'SMALL';
        previewImage?: string;
      }
    | {
        type: 'LARGE';
        institutionUrl: string;
        previewImage?: string;
      };
}>;

export const NuggetInstitution = ({ variant }: NuggetInstitutionProps): ReactElement => {
  const [isPreviewImageLoaded, setIsPreviewImageLoaded] = useState(false);

  if (variant.type === 'LARGE') {
    return variant.previewImage ? (
      <Box
        sx={{ ...imageContainerStyle, display: isPreviewImageLoaded ? 'flex' : 'none' }}
        onClick={() => window.open(variant.institutionUrl, '_blank')}
        onError={() => setIsPreviewImageLoaded(false)}
        onLoad={() => setIsPreviewImageLoaded(true)}
      >
        <img src={variant.previewImage} alt={variant.institutionUrl} style={imageStyle} />

        <Box
          component="a"
          href={variant.institutionUrl}
          target="_blank"
          rel="noopener noreferrer"
          sx={institutionUrlStyle}
        >
          {variant.institutionUrl}
        </Box>
      </Box>
    ) : (
      <Box sx={institutionUrlStyle}>
        <Typography
          variant="body1"
          component="a"
          href={variant.institutionUrl}
          target="_blank"
          rel="noopener noreferrer"
        >
          {variant.institutionUrl}
        </Typography>
      </Box>
    );
  }

  return (
    <>
      {variant.previewImage && (
        <Box
          component="img"
          src={variant.previewImage}
          alt="Institution"
          sx={{ ...smallImageContainerStyle, display: isPreviewImageLoaded ? 'block' : 'none' }}
          onError={() => setIsPreviewImageLoaded(false)}
          onLoad={() => setIsPreviewImageLoaded(true)}
        />
      )}
    </>
  );
};

const imageContainerStyle: SxProps<Theme> = {
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'flex-start',
  alignItems: 'flex-start',
  overflow: 'hidden',
  width: '100%',
  height: 'auto',
  mt: 6,
  cursor: 'pointer',
};

const smallImageContainerStyle: SxProps<Theme> = {
  ...imageContainerStyle,
  maxHeight: '150px',
  minHeight: 'unset',
  width: '100%',
  backgroundColor: 'transparent',
  borderRadius: '16px',
  objectFit: 'cover',
  aspectRatio: '16/9',
};

const imageStyle: CSSProperties = {
  width: '100%',
  height: '100%',
  objectFit: 'cover',
  borderRadius: '16px',
  aspectRatio: '16/9',
  maxHeight: '450px',
};

const institutionUrlStyle: SxProps<Theme> = {
  cursor: 'pointer',
  mt: 1,
};
